import { trpc } from '@tencent/tpro_rmonitor_ai_server';
import { Modal, List } from 'antd';
import { throttle } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { aiCopilotServer } from '@/service/ai-copilot';
import { WithTypeCast } from '@raft/utils';
import HistoryQueryIcon from './icons/history-query.react.svg?react';
import style from './index.module.scss';

type ISessionData = WithTypeCast<trpc.rmonitor.ai_server.ISessionData>;
type IMessage = WithTypeCast<trpc.rmonitor.ai_server.IMessage[]>;

export const HistoryModal = (props: {getHistoryDetail: (historyQA: IMessage) => void }) => {
  const { getHistoryDetail } = props;
  const [history, setHistory] = useState<ISessionData[]>([]);
  const [visible, setVisible] = useState(false);
  const [offset, setOffset] = useState(0);
  const [reqBlock, setReqBlock] = useState(false);
  const listBoxRef = useRef<HTMLDivElement | null>(null);

  const handleScrollThro = throttle((event: any) => {
    if (event?.target.scrollHeight - event?.target.scrollTop <= event?.target.clientHeight + 1) {
      setOffset(offset => offset + 500);
      setReqBlock(false);
    }
  }, 100);
  const handleScroll = useCallback(handleScrollThro, []);

  const getSessionList = async (offset: number) => {
    const resp = await aiCopilotServer.getSessionList({ limit: 500, offset });
    if (resp.sessions && resp.sessions.length !== 0) {
      setHistory([...history, ...resp.sessions]);
      setReqBlock(true);
    } else {
      listBoxRef.current?.removeEventListener('scroll', handleScroll);
      setReqBlock(true);
    }
  };

  const toggleHistoryModal = () => {
    setVisible(!visible);
  };

  const historyModalClose = () => {
    setVisible(false);
  };

  const getHistoryQA = async (sessionId: string) => {
    const resp = await aiCopilotServer.getHistoryQA({
      offset: 0,
      sessionId,
    });
    resp.msg && getHistoryDetail(resp.msg);
  };

  useEffect(() => {
    if (listBoxRef.current && !reqBlock) {
      listBoxRef.current.addEventListener('scroll', handleScroll);
    }
    if (visible && !reqBlock) {
      getSessionList(offset);
    }
    return () => {
      listBoxRef.current?.removeEventListener('scroll', handleScroll);
    };
  }, [visible]);

  useEffect(() => {
    if (visible && !reqBlock) {
      getSessionList(offset);
    }
  }, [offset, reqBlock]);

  return (
    <div>
      <span onClick={toggleHistoryModal} style={{ cursor: 'pointer' }}>
        <HistoryQueryIcon />
      </span>
      <Modal
        title="历史对话记录"
        visible={visible}
        mask={false}
        closable={false}
        className={style.historyModal}
        onCancel={historyModalClose}
        getContainer={
          document.getElementsByClassName(style.drawer)?.[0] as HTMLElement
        }
      >
        <div className={style.listBox} ref={listBoxRef} >
          <List
            bordered
            dataSource={history}
            renderItem={item => (
              <List.Item
                onClick={() => {
                  getHistoryQA(item.sessionId!);
                  historyModalClose();
                }}
                style={{ cursor: 'pointer', overflowWrap: 'anywhere' }}
                extra={<span style={{ whiteSpace: 'nowrap', color: 'gray', paddingLeft: '5px' }}>{moment(item.createTime, 'X').format('YYYY-MM-DD HH:mm:ss')}</span>}
              >
                <span>{item.title}</span>
              </List.Item>
            )}
          />
        </div>

      </Modal>
    </div>
  );
};

export default HistoryModal;

